<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();

onMounted(() => {
   
})


</script>

<template>
    <div class = "lap-counter">
        <div class = 'nascar-icon-area flex-center'>
            <img class = "nascar-icon" src = "../../public/assets/imgs/top5.png">
        </div>
        <div class = "lap-area flex-center">
            <div class = "lap-text" v-if = "store.getters.raceMetadata">
                Lap {{ store.getters.raceMetadata?.ttl_laps - store.getters.lapsRemaining }} of {{ store.getters.raceMetadata?.ttl_laps}}
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '../sass/GlobalClasses';
@import '../sass/Settings';

.lap-counter {
    position: absolute;
    top: vw(20);
    left: 0;
    right: 0;
    height: vw(45);

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.nascar-icon-area {
    position: relative;
    width: vw(59);
    height: 100%;
    background: linear-gradient(132.96deg, rgba(199, 199, 199, 0.5) -27.09%, rgba(79, 79, 79, 0.5) 27.74%, rgba(129, 129, 129, 0.5) 99.43%);;
    border-radius: vw(6);

    img{
        position: relative;
        width: auto;
        height: vw(23);
    }
}

.lap-area{
    position: relative;
    width: vw(221);
    height: 100%;
    background: linear-gradient(132.96deg, rgba(199, 199, 199, 0.5) -27.09%, rgba(79, 79, 79, 0.5) 27.74%, rgba(129, 129, 129, 0.5) 99.43%);
    border-radius: vw(6);
    margin-left: vw(6);

    .lap-text{
        color: white;
        font-size: vw(24);
        font-weight: 700;

    }
}

</style>
